import { Accordion, AccordionContent, AccordionItem } from '@/components/ui/accordion';
import { Switch } from '@/components/ui/switch';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { PlusIcon } from 'lucide-react';
import { useEffect } from 'react';

export default function ManageConsentPreferences({
  data = {},
  checkListMap = {},
  setCheckListMap,
  cookiePreferencesName,
                                                   clearTimeout
}) {
  const { manageConsentLabel, preferences = [], alwaysActiveLabel } = data;

  useEffect(() => {
    localStorage.setItem(cookiePreferencesName, JSON.stringify(checkListMap));
  }, [cookiePreferencesName, checkListMap]);

  return (
    <div className='flex flex-col gap-4'>
      {manageConsentLabel && <h2 className='h5 font-semibold'>{manageConsentLabel}</h2>}
      <Accordion type='single' collapsible className='w-full' defaultValue='3'>
        {preferences.map(item => (
          <AccordionItem
            value={item.id}
            key={item.id}
            className='has-focus-visible:border-ring has-focus-visible:ring-ring/50 relative border border-black/10 px-4 py-1 outline-none first:rounded-t-md last:rounded-b-md last:border-b has-focus-visible:z-10 has-focus-visible:ring-[3px] -mt-px'
          >
            <AccordionPrimitive.Header asChild>
              <AccordionPrimitive.Trigger
                asChild
                className='cursor-pointer select-none flex w-full items-center gap-2.5 xs:gap-4 rounded-md py-2 text-left text-xs sm:text-sm leading-6 font-semibold transition-all outline-none focus-visible:ring-0 [&>svg]:-order-1 [&>svg>path:last-child]:origin-center [&>svg>path:last-child]:transition-all [&>svg>path:last-child]:duration-200 [&[data-state=open]>svg]:rotate-180 [&[data-state=open]>svg>path:last-child]:rotate-90 [&[data-state=open]>svg>path:last-child]:opacity-0'
              >
                <div>
                  {item.label}

                  <PlusIcon
                    size={16}
                    className='pointer-events-none shrink-0 opacity-60 transition-transform duration-200'
                    aria-hidden='true'
                  />

                  {!item.haveSwitch && alwaysActiveLabel && (
                    <span className='ms-auto text-secondary whitespace-nowrap'>{alwaysActiveLabel}</span>
                  )}

                  {item.haveSwitch && (
                    <Switch
                      id={item.id}
                      aria-label='Toggle switch'
                      className='ms-auto'
                      checked={checkListMap[item.id]?.checked}
                      onCheckedChange={checked => {
                        setCheckListMap(prev => ({ ...prev, [item.id]: { checked } }));
                      }}
                      onClick={event => {
                        clearTimeout();
                        event.stopPropagation();
                      }}
                    />
                  )}
                </div>
              </AccordionPrimitive.Trigger>
            </AccordionPrimitive.Header>
            <AccordionContent className='text-muted-foreground pb-2'>{item.body}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
